import React from 'react';
import { get } from 'lodash';
import * as PropTypes from 'prop-types';
import { BaseCard, BaseCardBody, BaseCardHeader } from '@unite-us/ui';
import '../AppClientProfile.scss';
import ContactInformation from './ContactInformation';
import ContactRequirements from './ContactRequirements';
import ExternalIdentifiers from './ExternalIdentifiers';
import HouseholdInformation from './HouseholdInformation';
import InformedConsent from './InformedConsent';
import { InsuranceInformation } from './InsuranceInformation/InsuranceInformation';
import MilitaryInformation from './MilitaryInformation';
import PersonalData from './PersonalData';
import { SocialInsuranceInformation } from './SocialInsuranceInformation/SocialInsuranceInformation';
import { useAppContext } from '../context/context';
import { hooks } from '../config/api';
import Spinner from './common/spinners/Spinner';
export var FacesheetProfile = function FacesheetProfile(_ref) {
  var _data$data;
  var contact = _ref.contact,
    goToEnrollmentWorkflow = _ref.goToEnrollmentWorkflow,
    groupId = _ref.groupId,
    lastUpdates = _ref.lastUpdates,
    networkId = _ref.networkId,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate,
    shouldShowSexualityFields = _ref.shouldShowSexualityFields,
    shouldShowExternalIdentifiers = _ref.shouldShowExternalIdentifiers,
    limitedGenderOptions = _ref.limitedGenderOptions,
    shouldShowPreferredLanguages = _ref.shouldShowPreferredLanguages,
    shouldShowPopulationsAndConditions = _ref.shouldShowPopulationsAndConditions;
  var _useAppContext = useAppContext(),
    fieldsConfig = _useAppContext.state.fieldsConfig;
  var showEdit = get(fieldsConfig, "insuranceSection.showEdit");
  var _hooks$useFindRecord = hooks.useFindRecord("provider", groupId, {
      queryConfig: {
        placeholderData: undefined,
        enabled: !(showEdit === false)
      }
    }),
    data = _hooks$useFindRecord.data,
    isFetching = _hooks$useFindRecord.isFetching,
    isLoading = _hooks$useFindRecord.isLoading;
  var healthInsuranceFocus = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.data) === null || _data$data === void 0 || (_data$data = _data$data.focus) === null || _data$data === void 0 ? void 0 : _data$data.health_insurance_focus;
  return /*#__PURE__*/React.createElement(BaseCard, {
    className: "facesheet-profile"
  }, /*#__PURE__*/React.createElement(BaseCardHeader, {
    title: "".concat(contact.full_name, "'s Profile")
  }), /*#__PURE__*/React.createElement(BaseCardBody, {
    withPadding: true
  }, shouldShowExternalIdentifiers ? /*#__PURE__*/React.createElement("div", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(ExternalIdentifiers, {
    contact: contact,
    groupId: groupId
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(ContactInformation, {
    contact: contact,
    lastUpdate: {
      addresses: lastUpdates.addresses,
      phoneNumbers: lastUpdates.phone_numbers
    },
    shouldShowLastUpdate: shouldShowLastUpdate
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(ContactRequirements, {
    contact: contact,
    shouldShowPreferredLanguages: shouldShowPreferredLanguages
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(PersonalData, {
    contact: contact,
    lastUpdate: lastUpdates.names,
    shouldShowLastUpdate: shouldShowLastUpdate,
    shouldShowSexualityFields: shouldShowSexualityFields,
    limitedGenderOptions: limitedGenderOptions,
    shouldShowPopulationsAndConditions: shouldShowPopulationsAndConditions
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(HouseholdInformation, {
    contact: contact
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(InformedConsent, {
    contact: contact
  })), !(showEdit === false) && (isFetching || isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : healthInsuranceFocus && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(InsuranceInformation, {
    contact: contact,
    lastUpdate: lastUpdates.insurances,
    shouldShowLastUpdate: shouldShowLastUpdate
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(SocialInsuranceInformation, {
    contact: contact,
    goToEnrollmentWorkflow: goToEnrollmentWorkflow,
    groupId: groupId,
    networkId: networkId,
    shouldShowLastUpdate: shouldShowLastUpdate,
    socialInsuranceLastUpdate: lastUpdates.social_care_coverages
  })))), /*#__PURE__*/React.createElement(MilitaryInformation, {
    contact: contact
  })));
};
FacesheetProfile.propTypes = {
  contact: PropTypes.object.isRequired,
  goToEnrollmentWorkflow: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  lastUpdates: PropTypes.object.isRequired,
  networkId: PropTypes.string.isRequired,
  shouldShowLastUpdate: PropTypes.bool.isRequired,
  shouldShowSexualityFields: PropTypes.bool.isRequired,
  shouldShowExternalIdentifiers: PropTypes.bool.isRequired,
  limitedGenderOptions: PropTypes.bool.isRequired,
  shouldShowPreferredLanguages: PropTypes.bool.isRequired,
  shouldShowPopulationsAndConditions: PropTypes.bool.isRequired
};
//# sourceMappingURL=FacesheetProfile.js.map